import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PaetepCfDisplayContextInfoComponent } from './components/paetep-cf-display-context-info/paetep-cf-display-context-info.component';
import { PaetepCfDisplaySignatureComponent } from './components/paetep-cf-display-signature/paetep-cf-display-signature.component';
import { ComponentsModule } from "../../../common-components/components.module";
import { EdlCustomFormCommonModule } from "@edl-development/edl-custom-forms";
import { PaetepDirectiveModule } from "src/app/directives/paetep-directive.module";
import { EdlCommonComponentsModule, EdlCommonDirectiveModule } from "@edl-development/edl-common";


@NgModule({
    declarations: [
        PaetepCfDisplayContextInfoComponent,
        PaetepCfDisplaySignatureComponent
    ],
    imports: [
        CommonModule,
        ComponentsModule,
        FormsModule,
        ReactiveFormsModule,
        EdlCustomFormCommonModule,
        PaetepDirectiveModule,
        EdlCommonComponentsModule,
        EdlCommonDirectiveModule
    ],
    exports: [
        PaetepCfDisplayContextInfoComponent,
        PaetepCfDisplaySignatureComponent
    ]
})
export class PaetepCFDisplayEnhancementsModule {}
